"use client";

import React, { useEffect, useState } from "react";

const useIsSaleScreen = () => {
  const [isSo, setIsSo] = useState<boolean>(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const value = localStorage?.getItem("isSo");
      if (value) {
        setIsSo(value === "true");
      }
    }
  }, []);

  return isSo;
};

export default useIsSaleScreen;
